import React from 'react';
import { Phone, ArrowRight, ShieldCheck, BadgeCheck, FileText } from 'lucide-react';
import { SITE, HERO_BG } from '../data/site';
import { TESTIDS } from '../constants/testIds';

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid={TESTIDS.heroSection}
      className="relative min-h-[100vh] flex items-center overflow-hidden grain"
    >
      {/* Background image with heavy dark overlay */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/90 to-[#050505]/40" />
        <div className="absolute inset-0 bg-[#050505]/30" />
      </div>

      {/* Decorative diagonal gold strip on the right */}
      <div className="absolute top-0 right-0 h-full w-2 bg-[#E8B842] hidden lg:block" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 w-full">
        <div className="max-w-4xl">
          <div className="reveal inline-flex items-center gap-2 border border-[#E8B842]/40 px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-[#E8B842] rounded-full animate-pulse" />
            <span className="font-display uppercase tracking-[0.3em] text-xs sm:text-sm text-[#E8B842]">
              {SITE.location}
            </span>
          </div>

          <h1
            className="reveal font-display uppercase font-extrabold leading-[0.9] text-white"
            style={{ animationDelay: '0.1s' }}
          >
            <span className="block text-5xl sm:text-7xl lg:text-8xl">Guttering</span>
            <span className="block text-5xl sm:text-7xl lg:text-8xl">
              & <span className="text-[#E8B842]">Fascia</span>
            </span>
            <span className="block text-5xl sm:text-7xl lg:text-8xl">Services</span>
          </h1>

          <p
            className="reveal mt-8 max-w-2xl text-lg sm:text-xl text-[#FDFBF7]/85 leading-relaxed"
            style={{ animationDelay: '0.25s' }}
          >
            Guttering, Fascia &amp; Soffit specialists serving Leamington Spa, Warwick,
            Kenilworth and the surrounding villages. UPVC Gutter, Fascia &amp; Soffit
            replacement, repairs, moss removal and hand cleaning &mdash; to the highest
            standard.
          </p>

          <div
            className="reveal mt-10 flex flex-col sm:flex-row gap-4"
            style={{ animationDelay: '0.4s' }}
          >
            <a
              href="#contact"
              data-testid={TESTIDS.heroCtaQuote}
              className="inline-flex items-center justify-center gap-2 bg-[#E8B842] hover:bg-[#F4C534] text-black font-display font-bold uppercase tracking-wider px-8 py-4 transition-all hover:scale-[1.02]"
            >
              Get a Free Quote
              <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href={SITE.phoneTel}
              data-testid={TESTIDS.heroCtaCall}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#E8B842] text-[#E8B842] hover:bg-[#E8B842] hover:text-black font-display font-bold uppercase tracking-wider px-8 py-4 transition-colors"
            >
              <Phone className="w-5 h-5" />
              Call Luke — {SITE.phoneDisplay}
            </a>
          </div>

          {/* Trust strip */}
          <div
            className="reveal mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl"
            style={{ animationDelay: '0.55s' }}
          >
            {[
              { Icon: ShieldCheck, label: 'Fully Insured' },
              { Icon: BadgeCheck, label: 'Guaranteed Work' },
              { Icon: FileText, label: 'Free Quotations' },
            ].map(({ Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-3 border-l-2 border-[#E8B842] pl-4 py-2"
              >
                <Icon className="w-6 h-6 text-[#E8B842]" />
                <span className="font-display uppercase tracking-wider text-sm text-white">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
